import React from 'react';

export function AboutSection() {
  return (
    <section id="s-about" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-about" data-reveal>
          <div className="franchise-about__banner">
            10 лет успешной работы
          </div>
          <div className="franchise-about__body">
            <div>
              <div className="franchise-about__body__nums">
                60+
              </div>
              <div className="franchise-about__body__text">
                точек
              </div>
            </div>
            <div>
              <div className="franchise-about__body__nums">
                45
              </div>
              <div className="franchise-about__body__text">
                городов
              </div>
            </div>
            <div>
              <div className="franchise-about__body__nums">
                96%
              </div>
              <div className="franchise-about__body__text">
                довольных <br /> гостей
              </div>
            </div>
            <div>
              <div className="franchise-about__body__nums">
                до 70%
              </div>
              <div className="franchise-about__body__text">
                заказов через <br /> собственную доставку
              </div>
            </div>
          </div>
          <div className="franchise-about__photos">
            <img src="/assets/media/franchise/about-section/ph1.jpg" alt="Фото" />
            <img src="/assets/media/franchise/about-section/ph2.jpg" alt="Фото" />
            <img src="/assets/media/franchise/about-section/ph3.jpg" alt="Фото" />
          </div>
        </div>
      </div>
    </section>
  );
}
